import React, { Component } from 'react';
import EventTimer from './eventTimer'
let emptyStateInterval
export default class TennisBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameCode: "2",
      runners:[],
      tvShow: false
    };
  }
  componentDidMount() {
    let runners = !!this.props.game.catalogues ? this.props.game.catalogues.filter((mkt) => {
      return mkt.marketType === "MATCH_ODDS"
    })[0] : {}
    if (!!runners) {
      runners = runners.runners
    }
    this.setState({runners:runners})

    emptyStateInterval = setInterval(() => { 
      clearInterval(emptyStateInterval)
      this.setState({}) 
    }, 1000)
  }
  componentWillUnmount(){
    clearInterval(emptyStateInterval)
  }
  formatDate(date) {
    if (!date) {
      return ""
    }
    date = new Date(date)
    let month = []
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min
    let year = date.getFullYear()
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
    return formatedDate
  }
  render() {
    let now = new Date().getTime()
    let eventTime = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() : now
    let isOpen = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() < now : false
    let score = this.props.frontData
    return (
      <>
        <div className="main-in-play tennisrlmargin">
          <div className="top grd-background">
            <h4 className="w-100">           
              {!!this.props.game && !!this.props.game.event && !!this.props.game.competition && 
                <>
                  <span>{!!this.props.game && !!this.props.game.event["name"] ? this.props.game.event["name"] : null} - {!!this.props.game && !!this.props.game.competition["name"] ? this.props.game.competition["name"] : null}</span> 
                  <span className="float-right">{this.formatDate(this.props.game.event["openDate"])}</span>
                  {this.props.beepAllow?<span className="ml-2" onClick={()=>{this.props.toggleBeep()}}><i className="fa fa-volume-up" aria-hidden="true"></i></span>:
                  <span className="ml-2" onClick={()=>{this.props.toggleBeep()}}><i className="fa fa-volume-off" aria-hidden="true"></i></span>}
                 </>
              }
            </h4>
          </div>
        </div>
        <div className="livetv mt-1" style={{ marginBottom: "-4px" }}>
                        {!!this.props.tvUrl && this.props.tvUrl !== "" && <>
                            <div className="center-box libtnonoff" >
                                <p style={{ width: "100%", maxWidth: "100%" }}>
                                    <span style={{ padding: "5px 0px 0px 5px", display: "inline-block" }}>Live TV</span>
                                    <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.setState({ tvShow: !this.state.tvShow }) }} >
                                        <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                        <label className="custom-control-label" for="customSwitches" ></label>
                                    </div>
                                </p>
                            </div>
                            {!!this.state.tvShow && <div className="mb-0 tviframe mobiletviframe" style={{ marginTop: "-8px", marginBottom: "-4px" }} > <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={this.props.tvUrl} marginwidth='0' marginheight='0' frameborder='0' width='100%' height='100%' scrolling='no' allowfullscreen='allowfullscreen'></iframe></div>}
                        </>}
                    </div>
        <div className="middle-in-play" style={{display:"none"}}>
                        {!isOpen?<EventTimer duration={(eventTime - now) / 1000} />:
                        <div className="event-main-box team-score-details tennisbgbox tennisrlpadding">
                            <div className="row">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="table table-sm tennisscore whitespace">
                                            <tbody>
                                                <tr className="text-center">
                                                    <td className="width-10tennis"></td>
                                                    <td className="text-left">Player</td>
                                                    <td className="width6">1</td>
                                                    <td className="width6">2</td>
                                                    <td className="width6">3</td>
                                                    <td className="width6">4</td>
                                                    <td className="width6">5</td>
                                                    <td>Points</td>
                                                    <td>Sets</td>
                                                </tr>
                                                <tr className="text-center tennisbgblack">
                                                    <td className="width-10tennis">{!!score && !!score.turn && score.turn ==="h" && <span className="soccer-lvnow"></span>}</td>
                                                    <td className="text-left">{this.state.runners && this.state.runners.length > 0 ? this.state.runners[0].name : !!score && !!score.c1?score.c1.n:""} <span></span> </td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S1 && score.ps.S1.status === 1 ?"text-success bg-black top-radius width6":""}>{!!score && !!score.ps && !!score.ps.S1 ? score.ps.S1.games.h : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S2 && score.ps.S2.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S2 ? score.ps.S2.games.h : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S3 && score.ps.S3.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S3 ? score.ps.S3.games.h : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S4 && score.ps.S4.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S4 ? score.ps.S4.games.h : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S5 && score.ps.S5.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S5 ? score.ps.S5.games.h : "0"}</td>
                                                    <td className="points top-radius">{!!score && !!score.ss ? score.ss.h : "0"}</td>
                                                    <td>{!!score && !!score.ps && !!score.ps.TN ? score.ps.TN.sets.h : "0"}</td>
                                                </tr>
                                                <tr className="text-center tennisbgblack">
                                                    <td className="width-10tennis">{!!score && !!score.turn && score.turn ==="a" && <span className="soccer-lvnow"></span>}</td>
                                                    <td className="text-left">{this.state.runners && this.state.runners.length > 1 ? this.state.runners[1].name : !!score && !!score.c2?score.c2.n:""} <span></span> </td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S1 && score.ps.S1.status === 1 ?"text-success bg-black bottom-radius width6":""}>{!!score && !!score.ps && !!score.ps.S1 ? score.ps.S1.games.a : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S2 && score.ps.S2.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S2 ? score.ps.S2.games.a : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S3 && score.ps.S3.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S3 ? score.ps.S3.games.a : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S4 && score.ps.S4.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S4 ? score.ps.S4.games.a : "0"}</td>
                                                    <td className={!!score && !!score.ps && !!score.ps.S5 && score.ps.S5.status === 1 ?"text-success bg-black width6":"width6"}>{!!score && !!score.ps && !!score.ps.S5 ? score.ps.S5.games.a : "0"}</td>
                                                    <td className="points bottom-radius">{!!score && !!score.ss ? score.ss.a : "0"}</td>
                                                    <td>{!!score && !!score.ps && !!score.ps.TN ? score.ps.TN.sets.a : "0"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
      </>
    )
  }
}
